// removed by extract-text-webpack-plugin
module.exports = {"tab":"_1T4UdPB7y-xR8m5d","selected":"_24DyGHxObB7Ost4E"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Tab.pcss
// module id = 480
// module chunks = 1